<template>
  <div class="r-customer-order">
    <div class="common-flex">
      <div class="status common-hover common-flex common-align-center"
           :style="{color:config.color,background:config.color+'30'}" v-if="config.content">
        <div style="padding: 0 4px;" @click="changeTip">{{ config.content }}</div>
        <Icon @click="delTips" style="display:block;font-size:16px" type="ios-close"/>
        <div class="status-after" :style="{borderTop: '20px solid' + config.color+'30'}"></div>
      </div>
      <div
        style="background: #e6e8eb; color: #081938; padding: 0 10px"
        class="status statusgray common-hover common-flex common-align-center"
        v-else
      >
        <div @click="addTip">{{ $t("cart.iconadd") }}</div>
      </div>
    </div>
    <div class="common-flex common-justify-between common-align-center">
      <div style="margin-right:20px">{{ index + 1 }}</div>
      <div class="product">
        <img :src="config.clothUrl" alt=""/>
        <div class="product-name">
          <div>{{ config.orderZhName }}</div>
        </div>
      </div>

      <!-- 235 -->
      <div
        class="
          product-code
          common-flex common-direction-column common-justify-center
        "
      >
        <div class="code">{{ config.code }}</div>
        <div class="attr">
          <span v-if="config.clothZhName">{{ config.clothZhName }} |</span>
          <span v-if="config.cusOrderCode">{{ config.cusOrderCode }} | </span
          >{{ config.pubDate }}
        </div>
        <div class="details">
          <span class="common-hover" @click="details">Details </span>
          <span class="common-hover" @click="handleCartBuyAgain">{{ $t("cart.buyAgain") }}</span>
          <!-- <span class="common-hover" @click="urgent">urgent | </span> -->
        </div>
      </div>
      <!-- 167 -->
      <div class="product-total">{{ config.unitPrice }}*{{ config.amount }}</div>
      <!-- 147 -->
      <div class="product-price">{{ config.price }}</div>
      <!-- 96 -->
      <div class="product-status common-flex common-align-center">
        <div class="radio"></div>
        <div>{{ config.statusName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "r-customer-order",
  data() {
    return {};
  },
  methods: {
    // 删除标签
    delTips() {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.$emit('delTips', this.config)
        },
      });
    },
    // 修改备注标签
    changeTip() {
      this.$emit("changeTip", this.config);
    },
    // 新增备注
    addTip() {
      this.$emit("addTip", this.config);
    },
    // 订单详情
    details() {
      this.$emit('details', this.config)
    },
    // 再次购买
    handleCartBuyAgain() {
      this.$emit("buyAgain", this.config);
    }
  },
  props: {
    config: Object,
    index: Number,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-customer-order {
  width: 760px;
  margin: 0 auto;
  padding: 0px 10px 20px;
  border-bottom: 1px solid #f0f0f0;

  .status {
    padding-left: 4px;
    height: 20px;
    line-height: 20px;
    background: #fbf1e6;
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    // color: #d87508;
    position: relative;
    margin-bottom: 4px;
  }

  .status-after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    // border-top: 20px solid #fbf1e6;
    border-right: 20px solid transparent;
    right: -20px;
    top: 0;
  }

  .statusgray::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 20px solid #E6E8EB;
    border-right: 20px solid transparent;
    right: -20px;
    top: 0;

  }

  .product {
    width: 76px;
    height: 76px;
    position: relative;
    margin-right: 15px;

    img {
      width: 76px;
      height: 76px;
    }
  }

  .product-name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 76px;
    height: 15px;
    line-height: 15px;
    background: rgba(8, 25, 56, 0.5);
    color: #fff;
    text-align: center;

    > div {
      font-size: 12px;
      transform: scale(0.83);
    }
  }

  .product-code {
    width: 235px;
    text-align: left;

    .code {
      font-size: 14px;
      font-weight: 600;
      color: #081938;
      line-height: 16px;
    }

    .attr {
      font-size: 12px;
      font-weight: 400;
      color: #081938;
      line-height: 14px;
      margin: 5px 0;
    }

    .details {
      font-size: 12px;
      font-weight: 400;
      text-decoration: underline;
      color: #0a4dcc;
      line-height: 14px;
    }
  }

  .product-total {
    width: 167px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #081938;
    line-height: 16px;
  }

  .product-price {
    width: 147px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #081938;
    line-height: 16px;
  }

  .product-status {
    width: 96px;
    text-align: right;
    color: #0a4dcc;

    .radio {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #0a4dcc;
      margin-right: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-customer-order.vue